export const getProjectType = () =>
  location.pathname.includes('single-phase')
    ? 'single-phase'
    : `multiple-phase`;
